module.exports = __webpack_public_path__ + "img/jiance1.bad7c4ba.png";